import { registerLocale, getDefaultLocale, setDefaultLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

// Import desired locales from date-fns
import { enUS, ru, uk } from 'date-fns/locale'

// Register the locales with react-datepicker
registerLocale('en', enUS)
registerLocale('ru', ru)
registerLocale('ua', uk)

// Optionally, you can set a global default locale using setDefaultLocale
//setDefaultLocale('en')

//console.log('!VENDOR - DATEPICKER - INIT!', { getDefaultLocale: getDefaultLocale() })

